import { defineNuxtPlugin } from '#app'
import ScaleSliderComponent from '~/components/surveyjs/scale-slider/index.vue'

export default defineNuxtPlugin(async (nuxtApp) => {
  const Survey = (await import('survey-vue3-ui')).default
  if (process.client) {
    await Promise.all([
      import('survey-core/survey-core.min.css'),
      import('survey-creator-core/survey-creator-core.min.css'),
    ]).catch(() => {
      const linkElements = [
        'https://unpkg.com/survey-core@2.2.2/survey-core.min.css',
        'https://unpkg.com/survey-creator-core@2.2.2/survey-creator-core.min.css',
      ]

      linkElements.forEach((href) => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = href
        document.head.appendChild(link)
      })
    })
  }

  nuxtApp.vueApp.component('SurveyComponent', Survey)
  nuxtApp.vueApp.component('survey-scale-slider', ScaleSliderComponent)
  if (process.client) {
    const ensureSurveyJSStyles = () => {
      const testElement = document.createElement('div')
      testElement.className = 'svc-creator'
      testElement.style.position = 'absolute'
      testElement.style.visibility = 'hidden'
      document.body.appendChild(testElement)

      const computedStyle = window.getComputedStyle(testElement)
      const hasStyles = computedStyle.display !== 'inline'

      document.body.removeChild(testElement)

      if (!hasStyles) {
        const linkElements = [
          'https://unpkg.com/survey-core@2.2.2/survey-core.min.css',
          'https://unpkg.com/survey-creator-core@2.2.2/survey-creator-core.min.css',
        ]

        linkElements.forEach((href) => {
          const link = document.createElement('link')
          link.rel = 'stylesheet'
          link.href = href
          document.head.appendChild(link)
        })
      }

      const style = document.createElement('style')
      style.textContent = `
        .svc-creator {
          height: 100% !important;
          width: 100% !important;
        }
        .sv_main .sv_container .sv_body {
          background-color: transparent !important;
        }
        .svc-tab-designer {
          height: calc(100vh - 100px) !important;
        }
      `
      document.head.appendChild(style)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ensureSurveyJSStyles)
    } else {
      ensureSurveyJSStyles()
    }
  }
})
